module.exports = require("@sindresorhus/is");